import { noteConstants } from "../_constants";

export const notesList = list => ({
  type: noteConstants.NOTE_LIST,
  list
});

export const workingNoteId = id => ({
  type: noteConstants.WORKING_NOTE_ID,
  id
});

export const workingNoteLocation = location => ({
  type: noteConstants.WORKING_NOTE_LOCATION,
  location
});

export const getNote = list => ({
  type: noteConstants.SELECTED_NOTE,
  list
});

export const notePermission = permission => ({
  type: noteConstants.NOTE_PERMISSION,
  permission
});

export const noteCreatePermission = permission => ({
  type: noteConstants.NOTE_CREATE_PERMISSION,
  permission
});

export const noteViewPermission = permission => ({
  type: noteConstants.NOTE_VIEW_PERMISSION,
  permission
});

export const noteMergePermission = permission => ({
  type: noteConstants.NOTE_MERGE_PERMISSION,
  permission
});

export const noteBulkResolvePermission = permission => ({
  type: noteConstants.NOTE_BULK_RESOLVE_PERMISSION,
  permission
});



// WEBPACK FOOTER //
// ./src/_actions/note.actions.js